import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/session/"
let isClicked = false

// initial state
const state = {
  data: []
}

// getters
const getters = {
  getAll: state => {
    return state.data
  },
  getById: state => id => {
    if (
      !id ||
      state.data.length === 0 ||
      typeof state.data.find(el => {
        return el.id_utilizador === id
      }) == "undefined"
    )
      return "-"
    return state.data.find(el => {
      return el.id_utilizador === id
    }).nome
  },
  getUser: state => id => {
    if (
      !id ||
      state.data.length === 0 ||
      typeof state.data.find(el => {
        return el.id_utilizador === id
      }) == "undefined"
    )
      return "-"
    return state.data.find(el => {
      return el.id_utilizador === id
    })
  },
  getAdministradores: state => {
    return state.data.filter(el => el.id_tipo_utilizador < 3)
  },
  getColaboradores: state => {
    return state.data.filter(el => el.id_tipo_utilizador > 2)
  }
}

// actions
const actions = {
  get({ commit }, params) {
    return axios
      .get(TABLE)
      .then(res => {
        _DECODE(res.data.data).then(r => {
          if (r) commit("setData", r)
          else commit("setData", null)
        })
      })
      .catch(err => {
        commit("setData", null)
      })
  },

  insert({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .post(TABLE, _TOKEN(params))
      .then(res => {
        dispatch("get")

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  update({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .put(TABLE, _TOKEN(params))
      .then(res => {
        dispatch("get")

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  delete({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .delete(TABLE + _TOKEN(params).data)
      .then(res => {
        dispatch("get")

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  }
}

// mutations
const mutations = {
  setData(state, data) {
    state.data = data ? data : []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
